"use strict";

export function initHomeSliderSwiper() {
    const swipers = new Swiper(".home-slider", {
        loop: true,
        loopAdditionalSlides: 1,
        spaceBetween: 2,
        resizeObserver: true,
        updateOnWindowResize: true,
        watchOverflow: true,
        freeModeSticky: true,
        nested: true,
        autoHeight: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
            type: 'bullets',
            bulletElement: 'custom',
            bulletActiveClass: 'active',
            bulletClass: 'home-slider__navigation',
            renderBullet: function (index, className) {
                return `<button class="home-slider__navigation" aria-label="Home slide - ${++index}"></button> `;
            },
        },
        autoplay: {
            delay: 5000,
            pauseOnMouseEnter: true,
            disableOnInteraction: false
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        lazy: {
            // checkInView: false,
            // scrollingElement: 'window',
            // loadPrevNext: false,
            // loadPrevNextAmount: 1,
            // loadOnTransitionStart: false,
            // elementClass: 'swiper-lazy',
            // loadingClass: 'swiper-lazy-loading',
            // loadedClass: 'swiper-lazy-loaded',
            // preloaderClass: 'swiper-lazy-preloader',
            checkInView: true,
            loadPrevNext: true,
            loadOnTransitionStart: true,
        },
        on: {
            slideChange: function(swiper) {
                if (swiper && swiper.autoplay?.running) {
                    const totalSlidesCount = swiper.wrapperEl.childElementCount;
                    const nextSlideIndex = swiper.activeIndex + 1 >= totalSlidesCount ? 0 : swiper.activeIndex + 1;
                    swiper.lazy.loadInSlide(nextSlideIndex);
                }
            },
            touchStart: function(swiper, event) {
                const totalSlidesCount = swiper.wrapperEl.childElementCount;
                const nextSlideIndex = swiper.activeIndex + 1 >= totalSlidesCount ? 0 : swiper.activeIndex + 1;
                const prevSlideIndex = swiper.activeIndex - 1 <= 0 ? totalSlidesCount : swiper.activeIndex - 1;
                swiper.lazy.loadInSlide(prevSlideIndex);
                swiper.lazy.loadInSlide(nextSlideIndex);
                for (let i = 0; i < totalSlidesCount; i++) {
                    if (![prevSlideIndex, swiper.activeIndex, nextSlideIndex].includes(i)) {
                        swiper.lazy.loadInSlide(i);
                    }
                }
            },
            lazyImageReady: (swiper) => {
                swiper.update();
            }
        }
    });
}

export function initHomeCategoryCarouselSwiper() {
    const swipers = new Swiper(".home-category-carousel", {
        loop: true,
        loopAdditionalSlides: 1,
        resizeObserver: true,
        updateOnWindowResize: true,
        watchOverflow: true,
        freeModeSticky: true,
        slidesPerView: 2,
        spaceBetween: 12,
        nested: true,
        autoplay: {
            delay: 5000,
            pauseOnMouseEnter: true,
            disableOnInteraction: false
        },
        navigation: {
            prevEl: ".skl-icon-angle-left",
            nextEl: ".skl-icon-angle-right",
        },
        breakpoints: {
            // Sync with css breakpoints
            576: {
                slidesPerView: 3,
            },
            768: {
                slidesPerView: 4,
            },
            992: {
                slidesPerView: 5,
            },
            1200: {
                slidesPerView: 6,
            },
            // 1600: {
            //     slidesPerView: 6,
            // },
            // 1920: {
            //     slidesPerView: 6,
            // },
        },
    });
}

export function initHomeCollectionsSliderSwiper() {
    const swipers = new Swiper(".collections-slider", {
        loop: true,
        loopAdditionalSlides: 1,
        spaceBetween: 30,
        resizeObserver: true,
        updateOnWindowResize: true,
        watchOverflow: true,
        freeModeSticky: true,
        nested: true,
        autoHeight: true,
        autoplay: {
            delay: 5000,
            pauseOnMouseEnter: true,
            disableOnInteraction: false
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        lazy: {
            checkInView: true,
            loadPrevNext: true,
            loadOnTransitionStart: true,
        },
        breakpoints: {
            // Sync with css breakpoints
            576: {
                slidesPerView: 2,
            },
        },
        on: {
            slideChange: function(swiper) {
                if (swiper && swiper.autoplay?.running) {
                    const totalSlidesCount = swiper.wrapperEl.childElementCount;
                    const nextSlideIndex = swiper.activeIndex + 1 >= totalSlidesCount ? 0 : swiper.activeIndex + 1;
                    swiper.lazy.loadInSlide(nextSlideIndex);
                }
            },
            touchStart: function(swiper, event) {
                const totalSlidesCount = swiper.wrapperEl.childElementCount;
                const nextSlideIndex = swiper.activeIndex + 1 >= totalSlidesCount ? 0 : swiper.activeIndex + 1;
                const prevSlideIndex = swiper.activeIndex - 1 <= 0 ? totalSlidesCount : swiper.activeIndex - 1;
                swiper.lazy.loadInSlide(prevSlideIndex);
                swiper.lazy.loadInSlide(nextSlideIndex);
                for (let i = 0; i < totalSlidesCount; i++) {
                    if (![prevSlideIndex, swiper.activeIndex, nextSlideIndex].includes(i)) {
                        swiper.lazy.loadInSlide(i);
                    }
                }
            },
            lazyImageReady: (swiper) => {
                swiper.update();
            }
        }
    });
}

export default function init() {
    if (!$('.home-page').length) {
        return;
    }

    initHomeSliderSwiper();
    initHomeCategoryCarouselSwiper();
    initHomeCollectionsSliderSwiper();
}
